var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M18 8.1v1.8h-1.862A7.21 7.21 0 0 1 9.9 16.138V18H8.1v-1.862A7.21 7.21 0 0 1 1.862 9.9H0V8.1h1.862A7.21 7.21 0 0 1 8.1 1.862V0h1.8v1.862A7.21 7.21 0 0 1 16.138 8.1zm-9 6.3c2.978 0 5.4-2.423 5.4-5.4S11.978 3.6 9 3.6A5.406 5.406 0 0 0 3.6 9c0 2.977 2.422 5.4 5.4 5.4m0-8.1a2.7 2.7 0 1 1 0 5.4 2.7 2.7 0 0 1 0-5.4"
})));
export default SvgLocation;